import { Alert, Stack } from "@mui/material";

import { Button } from "../buttons";
import { useEffect } from "react";

export function ErrorFallback({
  resetError,
  error,
}: {
  error: Error;
  resetError: () => void;
}) {
  useEffect(() => {
    if (process.env.VITE_ENV_NAME !== "prod") {
      console.error(error);
    }
  }, []);

  return (
    <Stack sx={{ maxWidth: 400, margin: "0 auto", padding: 2 }} spacing={2}>
      <Alert severity="error">Something went really wrong.</Alert>
      <Button onClick={resetError} variant="contained">
        Re-try
      </Button>
    </Stack>
  );
}
